export const initialState = {
  currentPolicyGuid: null,
};

export function FETCH_POLICY_DETAILS_NORMALIZATION(nextState, { result }) {
  nextState.currentPolicyGuid = result;
}

export function RESET_SELECTED_POLICY(nextState) {
  nextState.currentPolicyGuid = null;
}
